module.exports = __webpack_public_path__ + "img/logo-header.35dd797c.svg";